<div class="pill-box py-2">
  <app-pill
    *ngFor="let pill of pills"
    [value]="pill.value"
    [(selected)]="pill.selected"
    [editable]="editable"
  ></app-pill>
</div>
